'use client';

import { useRouter } from 'next/navigation';

import { useLogin } from '@/modules/authentication/application';

import { useToast } from '@packages/web-design-systems';

import type { LoginFormModel } from '../models/login.form-model';

export const useLoginForm = () => {
	const router = useRouter();
	const { submit } = useLogin();
	const { showError, showSuccess } = useToast();

	const execute = async (form: LoginFormModel) => {
		const result = await submit(form);

		if (result.isFailure) {
			showError({ title: 'Login failed. Please check your credentials and try again.' });

			return;
		}

		showSuccess({ title: 'Login successful!' });
		router.replace('/');
	};

	return { execute };
};
